"use client";

import { useState } from "react";
import { MapPin, Phone, Mail, Send, MessageCircle } from "lucide-react";
import "./index.css";

const WHATSAPP_NUMBER = "923335299121"; // 0333 5299121 in international format
const CONTACT_EMAIL = "css@orbitsecurities.com.pk";

export const offices = [
  {
    name: "Registered Office",
    address:
      "Suite 1101, 11th Floor, Trade Center Near Jung Press, I.I Chundrigar Road, Karachi",
    phone: "(+92) 21-32622075",
    email: "info@orbitsecurities.com.pk",
    mapSrc:
      "https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d14481.540450652528!2d67.0102072!3d24.8506932!3m2!1i1024!2i768!4f13.1!2m1!1sSuite%201101%2011th%20Floor%20Trade%20Center%20Near%20Jung%20Press%20.ii%20Chundrigar%20Road%20Karachi!5e0!3m2!1sen!2s!4v1741125564598!5m2!1sen!2s",
  },
  {
    name: "Branch Office",
    address:
      "Suite 92, 2nd Floor, PSX Main Building, I.I Chundrigar Road, Karachi",
    phone: "(+92) 21-32622075",
    email: "info@orbitsecurities.com.pk",
    mapSrc:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3620.439464337989!2d66.99372217832995!3d24.84883588885685!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06f79533c3%3A0x688986c88631e98a!2sI.I%20Chundrigar%20Rd%2C%20Karachi%2C%20Pakistan!5e0!3m2!1sen!2s!4v1741125744685!5m2!1sen!2s",
  },
];

export default function ContactUsEnhanced() {
  const [activeOffice, setActiveOffice] = useState(0);
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const composeText = () => {
    const lines = [
      form.name ? `Name: ${form.name}` : "",
      form.email ? `Email: ${form.email}` : "",
      form.subject ? `Subject: ${form.subject}` : "",
      "",
      form.message,
    ].filter((l) => l !== undefined);
    return lines.join("\n").trim();
  };

  const sendWhatsApp = (e) => {
    e.preventDefault();
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(composeText())}`;
    window.open(url, "_blank", "noopener");
  };

  const sendEmail = (e) => {
    e.preventDefault();
    const body = [
      form.name ? `Name: ${form.name}` : "",
      form.email ? `Email: ${form.email}` : "",
      "",
      form.message,
    ].join("\n").trim();
    window.location.href = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(form.subject || "Website Enquiry")}&body=${encodeURIComponent(body)}`;
  };

  const office = offices[activeOffice];

  return (
    <div className="cu-page">
      <div className="cu-wrap">

        {/* header */}
        <div className="cu-head">
          <div className="cu-eyebrow"><span className="cu-dash" />CONTACT US<span className="cu-dash" /></div>
          <h1 className="cu-title">GET IN <span>TOUCH</span></h1>
          <span className="cu-title-underline" />
          <p className="cu-desc">We’re here to help and answer any question you might have.</p>
        </div>

        {/* quick contact chips */}
        <div className="cu-chips">
          <a className="cu-chip wa" href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer">
            <MessageCircle size={18} /> <span><small>WhatsApp</small>0333 5299121</span>
          </a>
          <a className="cu-chip" href={`mailto:${CONTACT_EMAIL}`}>
            <Mail size={18} /> <span><small>Email</small>{CONTACT_EMAIL}</span>
          </a>
          <a className="cu-chip" href="tel:+922132622075">
            <Phone size={18} /> <span><small>Call</small>(+92) 21-32622075</span>
          </a>
        </div>

        <div className="cu-grid">
          {/* left: office + map */}
          <div className="cu-card">
            <div className="cu-office-tabs">
              {offices.map((o, i) => (
                <button
                  key={i}
                  className={`cu-office-tab ${i === activeOffice ? "active" : ""}`}
                  onClick={() => setActiveOffice(i)}
                >
                  {o.name}
                </button>
              ))}
            </div>

            <div className="cu-office-details">
              <h2 className="cu-office-name">{office.name}</h2>
              <p className="cu-office-info"><MapPin size={18} /> {office.address}</p>
              <p className="cu-office-info"><Phone size={18} /> {office.phone}</p>
              <p className="cu-office-info"><Mail size={18} /> {office.email}</p>
            </div>

            <div className="cu-map">
              <iframe
                src={office.mapSrc}
                className="cu-map-frame"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={`Google Map - ${office.name}`}
              ></iframe>
            </div>
          </div>

          {/* right: message form */}
          <div className="cu-card cu-form-card">
            <h2 className="cu-form-title">Send us a Message</h2>
            <form className="cu-form">
              <div className="cu-field">
                <label>Your Name</label>
                <input type="text" value={form.name} onChange={set("name")} placeholder="Enter your name" />
              </div>
              <div className="cu-field">
                <label>Your Email</label>
                <input type="email" value={form.email} onChange={set("email")} placeholder="Enter your email" />
              </div>
              <div className="cu-field">
                <label>Subject</label>
                <input type="text" value={form.subject} onChange={set("subject")} placeholder="Subject" />
              </div>
              <div className="cu-field">
                <label>Your Message</label>
                <textarea rows={5} value={form.message} onChange={set("message")} placeholder="Type your message…" />
              </div>

              <div className="cu-actions">
                <button type="button" className="cu-btn wa" onClick={sendWhatsApp}>
                  <MessageCircle size={18} /> Send via WhatsApp
                </button>
                <button type="button" className="cu-btn mail" onClick={sendEmail}>
                  <Send size={17} /> Send via Email
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
